import { SWReactIcons } from "@similarweb/icons";
import classNames from "classnames";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { MarkerInnerWrapper } from "../styledComponents";

export const EngagementWidgetsLegendSingleTemplate = (props) => {
    const { legendContainerClass, toggleSeries, legendItems, colors } = props;

    return (
        <div className={classNames("legend", "legend-data", "single", legendContainerClass)}>
            {legendItems?.map((item, index) => {
                return (
                    <div
                        className={classNames(
                            "legend-item",
                            { "legend-item--off": !!item.hidden },
                            { "legend-item--disabled": item.alwaysDisabled },
                        )}
                        onClick={() => toggleSeries(item, !!item.hidden)}
                        key={index}
                    >
                        <div className="legend-item-data">
                            {item.isWinner ? (
                                <SWReactIcons
                                    iconName="winner"
                                    size="xs"
                                    className="mmx-winner"
                                />
                            ) : null}
                            {dynamicFilterFilter()(item.data, item.format)}
                        </div>
                        <div className="site-image-and-name">
                            <MarkerInnerWrapper
                                className="item-marker--flat"
                                color={item.color || item.Color || colors[index]}
                            />
                            <span
                                className="item-name"
                                title={item.name || item.Title}
                            >
                                {item.name || item.Title}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
